import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';

import { confirmDialog } from 'primereact/confirmdialog';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import DocumentItem from '../../common/document/DocumentItem';
import DocumentPanel from '../../common/document/DocumentPanel';

function EventPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { navigationContext } = useNavigationContext();
  const [document, setDocument] = useState([]);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const fetchDocument = async () => {
    await privateFetch('GET', 'bassecour', `/cu/${accountContext.id}/file/`).then((res) => {
      setDocument(res);
    });
  };

  useEffect(() => {
    fetchDocument();
  }, [navigationContext]);

  const handleCreateDocument = () => {
    setPanelIsOpen(true);
    setSelectedDocument(null);
  };

  const createFile = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'bassecour',
      `/cu/${accountContext.id}/file/`,
      'Le document a bien été ajouté',
      eventForm,
      false,
      true
    ).then(() => {
      fetchDocument();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/file/${selectedDocument.id}/`,
      'Le document a bien été modifié',
      documentForm,
      false,
      true
    ).then(() => {
      fetchDocument();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  const handleDeleteDocument = async (document) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/file/${document.id}/`,
      'Le document a bien été supprimée'
    ).then(() => {
      fetchDocument();
      setSelectedDocument(undefined);
    });
  };

  const handleUpdateDocument = (document) => {
    setSelectedDocument(document);
    setPanelIsOpen(true);
  };

  const confirmDocumentDeletion = (document) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteDocument(document)
    });
  };

  const newEventAction = {
    onClick: handleCreateDocument,
    label: 'Ajouter un menu en PDF',
    icon: 'pi-plus'
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Menu" action={newEventAction}>
        {document ? (
          <DocumentItem
            document={document}
            onDelete={() => confirmDocumentDeletion(document)}
            onUpdate={() => handleUpdateDocument(document)}
          />
        ) : (
          <div className="empty-message">Pas de menu disponible</div>
        )}
      </PageWrapper>
      <DocumentPanel
        document={selectedDocument}
        loading={loading}
        isOpen={panelIsOpen}
        onClose={() => {
          setSelectedDocument(null);
          setPanelIsOpen(false);
        }}
        onCreate={createFile}
        onUpdate={updateDocument}
      />
    </div>
  );
}

export default EventPage;
